// @ts-nocheck
import componentsReducer, { StoreComponentsActions } from "@store/Framework/Store/Store/Components/ComponentsReducer";
import dataReducer, { StoreDataActions } from "@store/Framework/Store/Store/Data/DataReducer";
import pagesReducer, { StorePagesActions } from "@store/Framework/Store/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducers = {
    components: componentsReducer,
    data: dataReducer,
    pages: pagesReducer,
};

export type StoreActions = StoreComponentsActions | StoreDataActions | StorePagesActions;
export default combineReducers(storeReducers);
